// extracted by mini-css-extract-plugin
export default {"container":"ChatDetailTopBar_container__P2HaE","chatdetails":"ChatDetailTopBar_chatdetails__AVQZP","lnk":"ChatDetailTopBar_lnk__LR2wa"};